export const getLayout = state => {
  return state.layout
}
export const getTheme = state => {
  return state.theme
}
export const getSidebar = state => {
  return state.sidebar
}
export const getMenu = state => {
  return state.menu
}
export const getMenuOriginal = state => {
  return state.menuOriginal
}
